var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgForceSendSms = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20.158,
    viewBox: "0 0 18 20.158",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1018.749 -552.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1027.582,559.45h3.336v2.41a.662.662,0,0,0,1.136.456l4.5-4.5,0,0a.663.663,0,0,0,0-.937l-4.5-4.5a.653.653,0,0,0-.466-.2h-.007a.663.663,0,0,0-.662.666v2.4h-3.336a1.149,1.149,0,0,0-1.15,1.148v1.92h0A1.149,1.149,0,0,0,1027.582,559.45Zm.35-2.721h2.986a1.5,1.5,0,0,0,1.5-1.5v-.379l2.49,2.489-2.49,2.49v-.379a1.5,1.5,0,0,0-1.5-1.5h-2.986Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1035.257,567.1a.747.747,0,0,1-.746.746h-1.492a.746.746,0,0,0-.746.746v1.589l-3.315-2.206a.746.746,0,0,0-.414-.126h-7.557a.746.746,0,0,1-.746-.746v-8.953a.746.746,0,0,1,.746-.746h4.395v-1.491h-4.395a2.24,2.24,0,0,0-2.238,2.237v8.953a2.239,2.239,0,0,0,2.238,2.238h7.332l4.287,2.858a.746.746,0,0,0,1.034-.208.737.737,0,0,0,.125-.412v-2.241h.746a2.241,2.241,0,0,0,2.238-2.238v-6.713h-1.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1030.867,564.639h-7.824a.554.554,0,0,0,0,1.108h7.824a.554.554,0,0,0,0-1.108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1027.546,561.844h-4.5a.553.553,0,0,0,0,1.107h4.5a.553.553,0,0,0,0-1.107Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForceSendSms, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/force-send-sms.a652971c.svg";
export { ForwardRef as ReactComponent };